import { put } from 'redux-saga/effects';
import { recordingRequested } from 'features/recorder/recorderSlice';

export function* onRecordingRequestedSaga() {
  yield put(recordingRequested());
}
